import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import SvgIcon from 'material-ui-next/SvgIcon';
// Tells `material-ui-icons` to use `material-ui-next/SvgIcon` module
// instead of `material-ui/SvgIcon`.
global.__MUI_SvgIcon__ = SvgIcon;

ReactDOM.render(
  (<MuiThemeProvider><App /></MuiThemeProvider>),
  document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js